export default "__VITE_ASSET__BtUse50U__"